"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTileContainerBox = void 0;
var tslib_1 = require("tslib");
var asg_1 = require("@alinta-digital/asg");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.StyledTileContainerBox = (0, styled_components_1.default)(asg_1.Box)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: 100%;\n  box-shadow: '0px 2px 4px 0px #0000001a'};\n   ", "\n\n  :hover {\n    box-shadow: 0px 4px 8px 0px #00000033;\n  }\n"], ["\n  height: 100%;\n  box-shadow: '0px 2px 4px 0px #0000001a'};\n   ", "\n\n  :hover {\n    box-shadow: 0px 4px 8px 0px #00000033;\n  }\n"])), function (_a) {
    var onHoverCursor = _a.onHoverCursor;
    return onHoverCursor && 'cursor: pointer;';
});
var templateObject_1;
//# sourceMappingURL=Title.style.js.map